/**
 * WizardWelcome — shown before Step 1 for first-time users.
 * Sets expectations: what they'll build, how long it takes, and what the output looks like.
 */

interface WizardWelcomeProps {
  onStart: () => void;
}

export function WizardWelcome({ onStart }: Readonly<WizardWelcomeProps>) {
  return (
    <div className="wizard-welcome">
      <div className="wizard-welcome-content">
        <h2>Build your retirement picture</h2>
        <p className="wizard-welcome-subtitle">
          In about 10 minutes, you'll see a year-by-year projection of your retirement
          — income, spending, tax, and whether your money lasts.
        </p>

        <div className="wizard-welcome-preview">
          <div className="wizard-welcome-preview-card">
            <span className="wizard-welcome-preview-label">What you'll see</span>
            <ul className="wizard-welcome-preview-list">
              <li>How long your money could last</li>
              <li>Which accounts to draw from first</li>
              <li>How much tax you could pay each year</li>
              <li>What happens if markets fall early</li>
            </ul>
          </div>
        </div>

        <div className="wizard-welcome-info">
          <p>You can save and come back at any time. Your progress is auto-saved as you go.</p>
        </div>

        <button type="button" className="btn btn-primary wizard-welcome-start" onClick={onStart}>
          Start My Plan
        </button>
      </div>
    </div>
  );
}
